import React, { useEffect, useState } from 'react';
import api from '../services/api';
import logo from '../assets/FCI Logo - Cropped.png';
import '../css/requisition-app-styles.css';
import { Link } from 'react-router-dom';
import userIcon from '../img/User-Icon.png';
import TopBarIcons from './TopBarIcons';
import axios from 'axios';
import Sidebar from './Sidebar';


const RequisitionSubmissionSuccessMessage = () => {
    const [requisitions, setRequisitions] = useState([]);
    const theUserType = localStorage.getItem('userType');

  
    useEffect(() => {
      const fetchRequisitions = async () => {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/Requisition`);
          setRequisitions(response.data); 
        } catch (error) {
          console.error("Error fetching requisitions:", error);
        }
      };
  
      fetchRequisitions();
    }, []);

      
    return (
        <div id="wrapper">
          {/* Sidebar */}
          <Sidebar userType={theUserType} />

          {/* Content Wrapper */}

          <div id="content-wrapper" className="d-flex flex-column">

              {/* Main Content */}
              <div id="content">



              {/* Topbar */}
              <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

              {/* Sidebar Toggle (Topbar) */}
              <button id="sidebarToggleTop" className="btn btn-link d-md-none rounded-circle mr-3">
                  <i className="fa fa-bars"></i>
              </button>

              {/* Topbar Search */}
              <form className="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search">
                  <div className="input-group">
                      <input type="text" className="form-control bg-light border-0 small" placeholder="Search"
                          aria-label="Search" aria-describedby="basic-addon2" />
                      <div className="input-group-append">
                          <button className="btn btn-primary" type="button">
                              <i className="fas fa-search fa-sm"></i>
                          </button>
                      </div>
                  </div>
              </form>

    {/* Topbar Navbar */}
    <ul className="navbar-nav ml-auto">

        {/* Nav Item - Search Dropdown */}
        <TopBarIcons />
        
        

    </ul>

    </nav>
    {/* End of Topbar */}






        {/* Begin Page Content */}
        <div className="container-fluid">

            {/* Page Heading */}
          <div class="successful-submission">
            <div id="smaller-container">
              <h1 className="successful-submission-heading">Submitted</h1>
                <p id="success-text">Your Requisition has been submitted successfully. The reviewers have also been notified about this requisition submission.</p>

                <div id = "make-another-requisition">
                  <button type="button" className="btn btn-primary"> <Link className="btn btn-primary" to="/reqform">Make Another Requisition</Link></button>
              </div>

            </div>
          </div>





        </div>
        {/* End of container-fluid */}

    </div>
    {/* End of Main Content */}

    {/* Footer */}
    <footer className="sticky-footer bg-white">
        <div className="container my-auto">
            <div className="copyright text-center my-auto">
                <span>Copyright &copy; Farm Concern International 2025 </span>
            </div>
        </div>
    </footer>
    {/* End of Footer */}

</div>


    
    {/* End of Content Wrapper */}


           
          
          
        </div>

  );
   
};

export default RequisitionSubmissionSuccessMessage;